import { EventBus } from "./event-bus";
import Vue from "vue";

window.OnlineServicesParticulieren = window.OnlineServicesParticulieren || {};
(function(OnlineServicesParticulieren) {
  "use strict";

  function VehicleDetailsHeader() {
    const vm = new Vue({
      el: "#header-heading",
      data: function data() {
        return {
          vehicle: null
        };
      },
      mounted: function() {
        EventBus.$on("vehicle-data-available", payload => {
          vm.vehicle = payload;
        });
      }
    });
  }

  OnlineServicesParticulieren.VehicleDetailsHeader = VehicleDetailsHeader;
})(window.OnlineServicesParticulieren);
